<template>
  <div class="banner-wrapper">
    <div class="banner-container" v-if="hasItems">
      <div class="banner-overlay" @click="onClickEditBanner">
        <div class="edit-button">
          <i class="fa fa-pencil fa-2x" />
        </div>
      </div>
      <BannerItem :data="items[0]" :thumborSize="items[0].coverImage.urls.content1920w ? 'content1920w' : 'cover1280w720h'"/>
    </div>
    <EmptyMessage class="empty-container" v-if="!hasItems">
      <button
        class="btn btn-light btn-lg mt-4"
        type="button"
        @click="onClickEditBanner()">
          จัดการแบนเนอร์
      </button>
    </EmptyMessage>
  </div>
</template>

<script>
import EmptyMessage from '@/components/EmptyMessage.vue';
import BannerItem from './BannerItem.vue';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    bannerId: {
      type: String,
      required: true,
    },
  },
  components: {
    BannerItem,
    EmptyMessage,
  },
  computed: {
    pageDesignerKey() {
      return this.$route.params.pageDesignerKey;
    },
    hasItems() {
      if (!this.items) {
        return false;
      } if (this.items.length === 0) {
        return false;
      }
      return true;
    },
  },
  methods: {
    onClickEditBanner() {
      this.$router.push(`${this.pageDesignerKey}/components/${this.bannerId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.banner-container {
  position: relative;
  .banner-overlay {
    cursor: pointer;
    position: absolute;
    transition: all 0.2s ease-out;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2;
    .edit-button {
      background: white;
      padding: $spacer / 2;
      margin-top: $spacer;
      margin-right: $spacer;
      border-radius: 15px;
      color: $gray-800;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}

.empty-container {
  background: white;
}

@media (max-width: 575.98px) {
  .edit-button {
    font-size: 8px;
    border-radius: 10px !important;
  }
}
</style>
